<template lang="pug">
  el-table.table(
    :data="dados"
    @sort-change='sortChanged'
    v-bind="config"
    )
    template(slot="empty") Não há registros.
    el-table-column(v-if="isVtn")
      template(slot-scope='scope')
        el-checkbox(
          v-if="exibirCheckBox[scope.$index]"
          :ref="`checkBox-${ scope.$index }`"
          @change="selectCheckBox(scope.$index)"
          :disabled="listaAtualizada[scope.$index]"
        )
    el-table-column(
      v-for="coluna in colunas"
      :prop='coluna.prop'
      :label='coluna.label',
      :width="coluna.width || 'auto'"
      :formatter="coluna.formatter || Utils.formatEmptyRow"
      :sortable='coluna.sortable || false'
      :key='coluna.label'
    )
    el-table-column(
      label='Ações'
      width='120'
      v-if="botoesAcao"
    )
      template(slot-scope='scope')
        el-button(
          v-if="isOneAction"
          type="danger"
          icon="el-icon-delete"
          @click="botoesAcao(scope.row)"
          )
        button-acoes(
          v-if="!isOneAction"
          :acoes="botoesAcao(scope.row)"
          )
</template>

<script>
import ButtonAcoes from '@/components/ButtonAcoes'
import Utils from '@/utils/utils'

export default {
  /* a prop colunas representa as colunas da tabela
    para utilizar é necessário passar um array de objetos
    colunas:
      [{
        prop: chave para os valores da coluna da prop dados,
        label: label da coluna,
        width: tamanho da coluna,
        formatter: formatador ,
        sortable: tipo de ordenação,
      }],
    botoesAcao: callback para setar ações dos botões,
    sortChanged: callback de ordenação,
    dados: array de dados que para popular a tabela

    exemplo em src\screens\arrecadacao\gat\components\Home.vue
  */
  components: { ButtonAcoes },

  props: {
    colunas: { required: true, type: Array },
    botoesAcao: { required: true },
    sortChanged: { required: false, type: Function, default: () => {} },
    dados: { required: true, type: Array },
    config: { default: () => {}, type: Object },
    isOneAction: { default: false },
    disableCheck: { required: false, type: Array },
    isVtn: {required: false, type: Boolean, default: false}
  },

  data () {
    return {
      Utils: Utils,
      checkBox: [],
      firstElement: '',
      exibirCheckBox: [],
      parcelasSelecionadasVtn: {
        parcelas: [],
        ordem: ''
      }
    }
  },

  created () {
    this.checkBox = this.disableCheck
    this.exibirCheckBox = Array(this.checkBox?.length).fill(true)
  },

  computed: {
    listaAtualizada () {
      return this.checkBox
    }
  },

  methods: {
    selectCheckBox (index) {
      const isChecked = this.$refs[`checkBox-${index}`].isChecked
      this.parcelasSelecionadasVtn.ordem = index === 0

      if (isChecked) {
        this.parcelasSelecionadasVtn.parcelas.push(index + 1)
        this.$emit('parcelaAdicionada', this.parcelasSelecionadasVtn)
      } else {
        this.parcelasSelecionadasVtn.parcelas = this.parcelasSelecionadasVtn.parcelas.filter(function (p) { return p !== index + 1 })
        this.$emit('parcelaAdicionada', this.parcelasSelecionadasVtn)
      }
      const linha = document.getElementsByClassName('el-table__row')[index]
      linha.style.backgroundColor = isChecked ? 'lightgreen' : ''

      this.ordemSelecao(index)
      this.desabilitaAnteriores(index)
      this.habilitaProximos(index)
    },

    ordemSelecao (index) {
      const ultimoElemento = this.checkBox?.length - 1
      if (index === 0) {
        this.firstElement = true
        this.$refs[`checkBox-${ultimoElemento}`].disabled = !this.$refs[`checkBox-${ultimoElemento}`].disabled
      } else if (index === this.checkBox?.length - 1) {
        this.firstElement = false
        this.$refs[`checkBox-${0}`].disabled = !this.$refs[`checkBox-${0}`].disabled
      }
    },

    desabilitaAnteriores (index) {
      if (this.firstElement) {
        if (index !== 0) {
          this.$refs[`checkBox-${index - 1}`].disabled = !this.$refs[`checkBox-${index - 1}`].disabled
        }
      } else {
        if (index !== this.checkBox?.length - 1) {
          this.$refs[`checkBox-${index + 1}`].disabled = !this.$refs[`checkBox-${index + 1}`].disabled
        }
      }
    },

    habilitaProximos (index) {
      const isChecked = this.$refs[`checkBox-${index}`].isChecked
      if (isChecked === true) {
        if (this.firstElement) {
          this.checkBox[index + 1] = false
          this.$refs[`checkBox-${index + 1}`].disabled = false
        } else {
          this.checkBox[index - 1] = false
          this.$refs[`checkBox-${index - 1}`].disabled = false
        }
      } else {
        if (!this.firstElement) {
          this.checkBox[index - 1] = true
          this.$refs[`checkBox-${index - 1}`].disabled = true
        } else {
          this.checkBox[index + 1] = true
          this.$refs[`checkBox-${index + 1}`].disabled = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container {
  display: flex;
  width: 100%;
  min-height: 100%;
}

.titulo {
  color: $--color-primary;
  margin-top: 3px;
}

.table {
  width: 100%;
}

.button {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/TableGenerica.vue